import ajax from "@/common/ajax.js";

// 以原密码修改密码
export function updatePassword(data) {
  return ajax.request.post("/api/account/updatePassword", data);
}

// 绑定手机号
export function set_mobile(data) {
  return ajax.request.post("/api/account/bindPhone", data);
}

// 换绑前验证原手机号码
export function validOldPhone(data) {
  return ajax.request.post("/api/account/validOldPhone", data);
}

// 换绑手机
export function changeBindPhone(data) {
  return ajax.request.post("/api/account/changeBindPhone", data);
}
